import Swal from 'sweetalert2';

type CallcountPayload = {
  token: string;
  touchDate: string;
  touchURL: string;
  elemId: string;
  gclid?: string;
  yclid?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_content?: string;
  utm_campaign?: string;
};

const API_TOKEN = 'GsM3YusXEg';
const CALLCOUNT_ENDPOINT = '/group-ta/lp/callcount.php';
const TRACKING_KEYS = [
  'gclid',
  'yclid',
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
  'utm_campaign',
] as const;

const isSmartphoneView = () => window.matchMedia('(max-width: 768px)').matches;

const formatCurrentDate = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mi = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd} ${hh}:${mi}:${ss}`;
};

const buildPayload = (elemId: string): CallcountPayload => {
  const payload: CallcountPayload = {
    token: API_TOKEN,
    touchDate: formatCurrentDate(),
    touchURL: window.location.href.replace(/\?.*$/, ''),
    elemId,
  };

  const params = new URLSearchParams(window.location.search);
  for (const key of TRACKING_KEYS) {
    const value = params.get(key);
    if (value) {
      payload[key] = value;
    }
  }

  return payload;
};

const sendCallcount = async (payload: CallcountPayload) => {
  const body = new URLSearchParams(
    Object.entries(payload).reduce<Record<string, string>>((acc, [key, value]) => {
      if (value != null) {
        acc[key] = String(value);
      }
      return acc;
    }, {}),
  );
  const bodyString = body.toString();

  if (navigator.sendBeacon) {
    const blob = new Blob([bodyString], {
      type: 'application/x-www-form-urlencoded;charset=UTF-8',
    });
    const beaconAccepted = navigator.sendBeacon(CALLCOUNT_ENDPOINT, blob);
    if (beaconAccepted) {
      return;
    }
  }

  await fetch(CALLCOUNT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: bodyString,
    credentials: 'same-origin',
    keepalive: true,
  });
};

const openConfirmAndCall = (telNumber: string, elemId: string) => {
  Swal.fire({
    // title: 'お電話でお問い合わせしますか？',
    // text: telNumber ? `電話番号: ${telNumber}` : '',
    // icon: 'question',
    customClass: {
      container: 'swal-on-top',
    },
    html: `
<div class="kakutei-sinkoku-link" style="font-size: 16px; font-weight: bold; margin-bottom: 24px;"><span style="color: #006600; font-size: 2em; text-decoration: underline;">確定申告</span>の相談はこちら</div>
<div class="zeimu-chousa-link" style="font-size: 16px; font-weight: bold;"><span style="color: #ff8b00; font-size: 2em; text-decoration: underline;">税務調査</span>の相談はこちら</div>
`,
    showConfirmButton: false,
    showCancelButton: false,
    confirmButtonText: '',
    cancelButtonText: '',
    reverseButtons: true,
    focusCancel: true,
    didOpen: () => {
      const popup = Swal.getPopup();
      if (!popup) return;

      const kakuteiLink = popup.querySelector<HTMLElement>('.kakutei-sinkoku-link');
      kakuteiLink?.addEventListener('click', () => {
        Swal.close();
        window.open('https://www.nta.go.jp/about/organization/access/map.htm', '_blank');
      });

      const zeimuLink = popup.querySelector<HTMLElement>('.zeimu-chousa-link');
      zeimuLink?.addEventListener('click', async () => {
        try {
          Swal.close();
          await sendCallcount(buildPayload(elemId || telNumber));
        } catch (error) {
          console.error('callcount error', error);
        }
        window.location.href = `tel:${telNumber}`;
      });
    },
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // 既存のaタグ
  const telAnchors = document.querySelectorAll<HTMLAnchorElement>('a.tel_link, a.tel-link');
  telAnchors.forEach((a) => {
    // 既存モーダル内のtelリンクは、そのまま発信させる（再ポップアップ防止）
    if (a.closest('.tel-link__modal')) return;

    a.addEventListener('click', (event) => {
      if (!isSmartphoneView()) return;
      const href = a.getAttribute('href') || '';
      if (!href.startsWith('tel:')) return;
      event.preventDefault();
      openConfirmAndCall(href.replace('tel:', '').trim(), a.id || '');
    });
  });

  // 追加: div.tel_link__toggle
  const toggles = document.querySelectorAll<HTMLElement>('.tel_link__toggle');
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      if (!isSmartphoneView()) return;
      event.preventDefault();

      const modalId = toggle.dataset.modalLink;
      if (!modalId) return;
      const modalTel = document.querySelector<HTMLAnchorElement>(`#${modalId} a.tel-link[href^="tel:"]`);
      if (!modalTel) return;

      const href = modalTel.getAttribute('href') || '';
      const telNumber = href.replace('tel:', '').trim();
      const elemId = modalTel.id || '';
      openConfirmAndCall(telNumber, elemId);
    });
  });
});
